
import { Dialog, DialogContent } from "@/components/ui/dialog";
import { SetData } from "../../../types";
import { useEditSetModalLogic } from "./hooks/useEditSetModalLogic";
import { ModalHeader } from "./components/ModalHeader";
import { ModalFormFields } from "./components/ModalFormFields";
import { ModalFooter } from "./components/ModalFooter";

interface EditSetModalProps {
  isOpen: boolean;
  onOpenChange: (open: boolean) => void;
  setIndex: number;
  setData: SetData;
  exerciseId: string;
  onSetDataChange: (setIndex: number, field: 'reps' | 'weight', value: string) => void;
}

export const EditSetModal = ({
  isOpen,
  onOpenChange,
  setIndex,
  setData,
  exerciseId,
  onSetDataChange
}: EditSetModalProps) => {
  const {
    localReps,
    localWeight,
    handleRepsChange,
    handleWeightChange,
    handleSave,
    handleCancel,
    handleOpenChange
  } = useEditSetModalLogic({
    isOpen,
    setData,
    setIndex,
    onSetDataChange,
    onOpenChange
  });

  return (
    <Dialog open={isOpen} onOpenChange={handleOpenChange}>
      <DialogContent className="sm:max-w-md bg-primary/50 border-primary/30" showCloseButton={false}>
        <ModalHeader setIndex={setIndex} />
        
        <div className="py-4">
          <ModalFormFields
            localReps={localReps}
            localWeight={localWeight}
            exerciseId={exerciseId}
            setIndex={setIndex}
            onRepsChange={handleRepsChange}
            onWeightChange={handleWeightChange}
          />

          <ModalFooter
            onCancel={handleCancel}
            onSave={handleSave}
          />
        </div>
      </DialogContent>
    </Dialog>
  );
};
